import React from "react";
import { styled } from "goober";
import { Button } from "clutch/src/Button/Button.jsx";

import { classNames } from "@/util/class-names.mjs";

const Styled = {
  ProButton: styled(Button)`
    border: none !important;

    .pro-btn--label {
      color: var(--shade0);
      background-size: 200% 100%;
      background-position: 0%;
    }

    .pro-btn--icon {
      transform: scale(1) rotate(0deg);
      transition: transform var(--transition);
    }

    &:hover {
      .pro-btn--icon {
        transform: scale(1.25) rotate(-10deg);
      }
    }
  `,
};

interface ProButtonProps {
  className?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  [x: string]: unknown;
}

export const SubscriberButton: React.FC<ProButtonProps> = ({
  className,
  children,
  icon,
  ...props
}) => (
  <Styled.ProButton
    bgColor="var(--subscriber-gradient)"
    bgColorHover="var(--subscriber-gradient)"
    {...classNames("pro-btn", className)}
    {...props}
  >
    <span className="flex gap-2 align-center">
      {icon && <span className="pro-btn--icon">{icon}</span>}
      <span className="pro-btn--label">{children}</span>
    </span>
  </Styled.ProButton>
);
